import { render, staticRenderFns } from "./VideoInput.vue?vue&type=template&id=0d470fee&scoped=true&"
import script from "./VideoInput.vue?vue&type=script&lang=js&"
export * from "./VideoInput.vue?vue&type=script&lang=js&"
import style0 from "./VideoInput.vue?vue&type=style&index=0&id=0d470fee&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d470fee",
  null
  
)

export default component.exports